"use strict";
import "../../api/api";
import { DocumentType, DocumentTypePartial } from "../../accounts_payable/data/types/Pb";
const invoiceName = (currentUser) => {
  if (currentUser && currentUser.account.factor_account === true) {
    return "Client Invoice / Billing Statement";
  }
  return "Carrier Invoice / Billing Statement";
};
const customerInvoiceName = (currentUser) => {
  if (currentUser && currentUser.account.factor_account === true) {
    return "Debtor Invoice";
  }
  return "Customer Invoice";
};
const Types = function() {
  this.types = function(currentUser) {
    return [
      {
        name: "Bill of Lading / Packing Slip",
        value: DocumentType.DocumentTypeBillOfLading
      },
      {
        name: "Lumper / Other Accessorial Receipt",
        value: DocumentType.DocumentTypeLaborReceipt
      },
      {
        name: "Delivery Order",
        value: DocumentType.DocumentTypeDeliveryOrder
      },
      {
        name: "Delivery Receipt",
        value: DocumentType.DocumentTypeProofOfDelivery
      },
      {
        name: invoiceName(currentUser),
        value: DocumentType.DocumentTypeInvoice,
        required: true
      },
      {
        name: "Carrier Invoice",
        value: DocumentType.DocumentTypeCarrierInvoice
      },
      {
        name: "Carrier Rate Confirmation",
        value: DocumentType.DocumentTypeCarrierRateConfirmation
      },
      {
        name: customerInvoiceName(currentUser),
        value: DocumentType.DocumentTypeCustomerInvoice
      },
      {
        name: "Factor Invoice / Billing Statement",
        value: DocumentType.DocumentTypeFactorInvoice
      },
      {
        name: "Funding Request Form",
        value: DocumentType.DocumentTypeFundingForm
      },
      {
        name: "Letter Of Assignment",
        value: DocumentType.DocumentTypeLetterOfAssignment
      },
      {
        name: "NMFC / W & I Certificate",
        value: DocumentType.DocumentTypeNmfcCertificate
      },
      {
        name: "Notice Of Assignment",
        value: DocumentType.DocumentTypeNoticeOfAssignment
      },
      {
        name: "Notice Of Release",
        value: DocumentType.DocumentTypeNoticeOfRelease
      },
      {
        name: "Customer Documents - Other",
        value: DocumentType.DocumentTypeCustomerDocumentsOther
      },
      {
        name: "Internal Documents - Other",
        value: DocumentType.DocumentTypeInternalDocumentsOther,
        required: true
      },
      {
        name: "Postal",
        value: DocumentType.DocumentTypePostal
      },
      {
        name: "Packing Slip",
        value: DocumentType.DocumentTypePackingSlip,
        deprecated: true
      },
      {
        name: "Rate Confirmation",
        value: DocumentType.DocumentTypeRateConfirmation
      },
      {
        name: "Trailer Interchange Report",
        value: DocumentType.DocumentTypeTir
      },
      {
        name: "Voided Check",
        value: DocumentType.DocumentTypeVoidedCheck
      },
      {
        name: "Weight Ticket / Gate Pass",
        value: DocumentType.DocumentTypeWeightTicket
      },
      {
        name: "Advance Request",
        value: DocumentType.DocumentTypeAdvanceRequest
      },
      {
        name: "Driver Form",
        value: DocumentType.DocumentTypeDriverForm
      },
      {
        name: "Escort Receipt",
        value: DocumentType.DocumentTypeEscortReceipt
      },
      {
        name: "ExitPass",
        value: DocumentType.DocumentTypeExitPass
      },
      {
        name: "Ferry Receipt",
        value: DocumentType.DocumentTypeFerryReceipt
      },
      {
        name: "Run Ticket",
        value: DocumentType.DocumentTypeRunTicket
      },
      {
        name: "Steaming Receipt",
        value: DocumentType.DocumentTypeSteamingReceipt
      },
      {
        name: "Toll Receipt",
        value: DocumentType.DocumentTypeTollReceipt
      },
      {
        name: "Wash Receipt",
        value: DocumentType.DocumentTypeWashReceipt
      },
      {
        name: "Insurance Certificate",
        value: DocumentType.DocumentTypeInsuranceCertificate
      },
      {
        name: "Contract",
        value: DocumentType.DocumentTypeContract
      },
      {
        name: "Detention Approval",
        value: DocumentType.DocumentTypeDetentionApproval
      },
      {
        name: "Email Approval",
        value: DocumentType.DocumentTypeEmailApproval
      },
      {
        name: "Layover Approval",
        value: DocumentType.DocumentTypeLayoverApproval
      },
      {
        name: "Lumper Approval",
        value: DocumentType.DocumentTypeLumperApproval
      },
      {
        name: "TONU Approval",
        value: DocumentType.DocumentTypeTonuApproval
      },
      {
        name: "MX BOL",
        value: DocumentType.DocumentTypeMxBol
      },
      {
        name: "Vendor Invoice",
        value: DocumentType.DocumentTypeVendorInvoice
      },
      {
        name: "Customer Rate Confirmation",
        value: DocumentType.DocumentTypeCustomerTender
      },
      {
        name: "W9",
        value: DocumentType.DocumentTypeW9
      },
      {
        name: "Authority",
        value: DocumentType.DocumentTypeAuthority
      },
      {
        name: "Balance Due",
        value: DocumentType.DocumentTypeBalanceDue
      },
      {
        name: "Claim",
        value: DocumentType.DocumentTypeClaim
      },
      {
        name: "Comcheck",
        value: DocumentType.DocumentTypeCoMCHeck
      },
      {
        name: "Customs Document",
        value: DocumentType.DocumentTypeCustomsDocument
      },
      {
        name: "ACH Setup Form",
        value: DocumentType.DocumentTypeAchSetupForm
      },
      {
        name: "Quote Doc",
        value: DocumentType.DocumentTypeQuote
      },
      {
        name: "Export Doc",
        value: DocumentType.DocumentTypeExport
      },
      {
        name: "Unknown",
        value: DocumentType.DocumentTypeUnknown
      },
      {
        name: "Purchase Order",
        value: DocumentType.DocumentTypePurchaseOrder
      },
      {
        name: "Pallet Receipt",
        value: DocumentType.DocumentTypePalletReceipt
      },
      {
        name: "Letter of Credit",
        value: DocumentType.DocumentTypeLetterOfCredit
      },
      {
        name: "Pre Alert",
        value: DocumentType.DocumentTypePreAlert
      },
      {
        name: "Shippers Letter of Instruction",
        value: DocumentType.DocumentTypeShippersLetterOfInstruction
      },
      {
        name: "Manifest",
        value: DocumentType.DocumentTypeManifest
      },
      {
        name: "House Airway Bill",
        value: DocumentType.DocumentTypeHouseAirwayBill
      },
      {
        name: "Master Airway Bill",
        value: DocumentType.DocumentTypeMasterAirwayBill
      },
      {
        name: "House Ocean Bill Of Lading",
        value: DocumentType.DocumentTypeHouseOceanBillOfLading
      },
      {
        name: "Master Ocean Bill Of Lading",
        value: DocumentType.DocumentTypeMasterOceanBillOfLading
      },
      {
        name: "Truck Bill of Lading",
        value: DocumentType.DocumentTypeTruckBillOfLading
      },
      {
        name: "Packing List",
        value: DocumentType.DocumentTypePackingList
      },
      {
        name: "Commercial Invoice",
        value: DocumentType.DocumentTypeCommercialInvoice
      },
      {
        name: "Certificate Of Origin",
        value: DocumentType.DocumentTypeCertificateOfOrigin
      },
      {
        name: "Inspection Certificate",
        value: DocumentType.DocumentTypeInspectionCertificate
      },
      {
        name: "Pickup Inspection",
        value: DocumentType.DocumentTypePickupInspectionCertificate
      },
      {
        name: "Dropoff Inspection",
        value: DocumentType.DocumentTypeDropoffInspectionCertificate
      },
      {
        name: "Master Bill of Lading",
        value: DocumentType.DocumentTypeMasterBillOfLading
      },
      {
        name: "Waybill",
        value: DocumentType.DocumentTypeWaybill
      },
      {
        name: "Weight Ticket (Unloaded)",
        value: DocumentType.DocumentTypeWeightTicketUnloaded
      },
      {
        name: "Form 1113",
        value: DocumentType.DocumentTypeForm1113
      },
      {
        name: "Government Bill Of Lading",
        value: DocumentType.DocumentTypeGovernmentBillOfLading
      },
      {
        name: "International Bill Of Lading",
        value: DocumentType.DocumentTypeInternationalBillOfLading
      },
      {
        name: "Internal Proof Of Delivery",
        value: DocumentType.DocumentTypeInternalProofOfDelivery
      },
      {
        name: "Demurrage Receipt",
        value: DocumentType.DocumentTypeDemurrageReceipt
      },
      {
        name: "Per Diem Receipt",
        value: DocumentType.DocumentTypePerDiemReceipt
      },
      {
        name: "Per Diem Invoice",
        value: DocumentType.DocumentTypePerDiemInvoice
      },
      {
        name: "Electronic Interchange Receipt",
        value: DocumentType.DocumentTypeElectronicInterchangeReceipt
      },
      {
        name: "Booking Confirmation",
        value: DocumentType.DocumentTypeBookingConfirmation
      },
      {
        name: "Gate Pass",
        value: DocumentType.DocumentTypeGatePass
      },
      {
        name: "Agent Invoice",
        value: DocumentType.DocumentTypeAgentInvoice
      },
      {
        name: "ISF Filing Instruction",
        value: DocumentType.DocumentTypeIsfFilingInstruction
      },
      {
        name: "Cartage Advice with Receipt",
        value: DocumentType.DocumentTypeCartageAdviceWithReceipt
      },
      {
        name: "House Bill of Lading",
        value: DocumentType.DocumentTypeHouseBillOfLading
      },
      {
        name: "Partial Specified Bill of Lading",
        value: DocumentTypePartial.DocumentTypePartialPartiallySpecifiedBillOfLading
      },
      {
        name: "US Customs Document",
        value: DocumentType.DocumentTypeUsCustomsDocument
      },
      {
        name: "Arrival Notice",
        value: DocumentType.DocumentTypeArrivalNotice
      },
      {
        name: "Dangerous Goods Declaration",
        value: DocumentType.DocumentTypeDangerousGoodsDeclaration
      },
      {
        name: "Permit to Transfer",
        value: DocumentType.DocumentTypePermitToTransfer
      },
      {
        name: "Repair Item",
        value: DocumentType.DocumentTypeRepairItem
      },
      {
        name: "Permit",
        value: DocumentType.DocumentTypePermit
      }
    ];
  };
};
const types = new Types();
export default types;
